import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CookieService } from '../Services/cookie';

@Component({
  selector: 'app-card-limit-success',
  templateUrl: './card-limit-success.component.html',
  standalone:false,
  styleUrls: ['./card-limit-success.component.scss']
})
export class CardLimitSuccessComponent implements OnInit {
  Decline: boolean = false;

  constructor(private location: Location, private router:Router,private _route:ActivatedRoute,private cookieService: CookieService,) { }

  ngOnInit(): void {
    this.cookieService.delete("AutoTempLimitObj");

    this._route.queryParams.subscribe(params => {
      if (params) {
        
       if(params['Decline']){
          this.Decline = JSON.parse(params['Decline']);


        }
      }
    })
  }


  Dashboard(){
    this.router.navigateByUrl('/DashboardCreditCards');
  }

}
